import RawMaterialFilterItem from 'components/Shared/RawMaterialFilter/RawMaterialFilterItem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  max-width: 100%;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 24px;
`;
const RawMaterialFilter = ({ variant = 'default', items = [], selectedId, hideAllSelection, highlightedIds, onSelectionChange, }) => {
    const { t } = useTranslation();
    return (React.createElement(Container, null,
        !hideAllSelection && (React.createElement(RawMaterialFilterItem, { variant: variant, id: "-1", selected: !selectedId, title: t('all'), onSelect: () => onSelectionChange(null) })),
        items.map((item) => (React.createElement(RawMaterialFilterItem, Object.assign({ variant: variant, key: item.id }, item, { highlighted: highlightedIds === null || highlightedIds === void 0 ? void 0 : highlightedIds.includes(item.id), selected: item.id === selectedId, onSelect: onSelectionChange }))))));
};
export default RawMaterialFilter;
